import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { resetPassword } from "../api/passwordService";

const NewPasswordPage = () => {
    const navigate = useNavigate();

    const [code, setCode] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const savedCode = sessionStorage.getItem("passwordRecoveryCode");

        if (!savedCode) {
            navigate("/recover-password");
            return;
        }

        setCode(savedCode);
    }, [navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setMessage("");
        setError("");

        if (newPassword !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        if (newPassword.length < 6) {
            setError("Password must be at least 6 characters.");
            return;
        }

        setLoading(true);

        try {
            const data = await resetPassword(code, newPassword);

            sessionStorage.removeItem("passwordRecoveryCode");

            setMessage(data?.message || "Password reset successfully.");

            setTimeout(() => {
                navigate("/login");
            }, 1200);
        } catch (err) {
            setError(
                err?.response?.data?.message ||
                err?.response?.data?.error ||
                "Error resetting password."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-slate-100 flex items-center justify-center px-4 py-10">
            <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl border border-slate-200 p-8">
                <h2 className="text-3xl font-bold text-center mb-4">
                    Create New Password
                </h2>

                <p className="text-slate-600 text-center mb-6">
                    Enter and confirm your new password.
                </p>

                <form onSubmit={handleSubmit} className="space-y-5">
                    <input
                        type="password"
                        placeholder="New password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        className="w-full px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-600"
                        required
                    />

                    <input
                        type="password"
                        placeholder="Confirm new password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        className="w-full px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-600"
                        required
                    />

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-xl transition disabled:opacity-60"
                    >
                        {loading ? "Saving..." : "Save New Password"}
                    </button>
                </form>

                {message && (
                    <div className="mt-5 p-3 rounded-lg bg-green-100 text-green-700 text-center">
                        {message}
                    </div>
                )}

                {error && (
                    <div className="mt-5 p-3 rounded-lg bg-red-100 text-red-700 text-center">
                        {error}
                    </div>
                )}
            </div>
        </div>
    );
};

export default NewPasswordPage;